import React from 'react'
import styles from './MicrositeTopPagesTable.module.css'

/**
 * MicrositeTopPagesTable
 * Specialized table for the "top pages by views" breakdown on
 * MicrositeAnalytics — slug, views, unique visitors, avg time,
 * bounce count, with a relative bar showing share of total views.
 *
 * Usage:
 *   <MicrositeTopPagesTable rows={viewStats.data} />
 */
const MicrositeTopPagesTable = ({ rows = [] }) => {
    if (!rows.length) {
        return <div className={styles.empty}>No page view data for this period yet</div>
    }

    const maxViews = Math.max(...rows.map((r) => Number(r.totalViews) || 0), 1)

    return (
        <div className={styles.wrap}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th className={styles.th}>Page</th>
                        <th className={styles.th} style={{ textAlign: 'right' }}>Views</th>
                        <th className={styles.th} style={{ textAlign: 'right' }}>Visitors</th>
                        <th className={styles.th} style={{ textAlign: 'right' }}>Avg. time</th>
                        <th className={styles.th} style={{ textAlign: 'right' }}>Bounces</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, idx) => {
                        const pct = (Number(row.totalViews) / maxViews) * 100
                        return (
                            <tr key={idx} className={styles.tr}>
                                <td className={styles.td}>
                                    <div className={styles.pageCell}>
                                        <span className={styles.slug}>{row.pageSlug}</span>
                                        <div className={styles.barTrack}>
                                            <div className={styles.barFill} style={{ width: `${pct}%` }} />
                                        </div>
                                    </div>
                                </td>
                                <td className={styles.tdRight}>{row.totalViews}</td>
                                <td className={styles.tdRight}>{row.uniqueVisitors}</td>
                                <td className={styles.tdRight}>{row.avgTimeOnPage ? `${Math.round(row.avgTimeOnPage)}s` : '—'}</td>
                                <td className={styles.tdRight}>{row.bounceCount ?? 0}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default MicrositeTopPagesTable